@if (groupCaption) {
  <div #groupCaptionElement class="groupCaption" [attr.title]="isEllipsisApplied ? groupCaption : null">
    {{ groupCaption }}
  </div>
}
@if (groupCaption) {
  <hr class="hrNavTitle" />
}
<abc-tree
  #abcTree
  (onItemClick)="nodeClick($event.node?.itemData)"
  [searchEnabled]="false"
  [showCheckBoxesMode]="'none'"
  [indicatorPosition]="'left'"
  [focusStateEnabled]="false"
  [hoverStateEnabled]="true"
  itemTemplate="list-item"
>
  <div
    *dxTemplate="let data of 'list-item'"
    [matBadge]="data.data?.badgeValue"
    [matBadgeHidden]="data.data?.badgeValue === 0"
    matBadgeColor="warn"
    matBadgeSize="small"
  >
    {{ data.caption }}
  </div>
</abc-tree>
